"use strict";
// This file was automatically generated by the Evolution Generator.
// The Evolution Generator is used to automate the creation of consistent, reliable code.
// Any changes made to this file will be overwritten.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sectionConfig = exports.currentSectionName = void 0;
const merge_1 = __importDefault(require("lodash/merge"));
const navigationHelpers_1 = require("evolution-common/lib/services/questionnaire/sections/navigationHelpers");
const widgetsNames_1 = require("./widgetsNames");
const customPreload_1 = require("./customPreload");
const helpers_1 = require("evolution-common/lib/utils/helpers");
const customHelpers_1 = require("../../common/customHelpers");
exports.currentSectionName = 'completed';
const previousSectionName = 'end';
const nextSectionName = null;
const parentSection = 'longDistance';
// Config for the section
exports.sectionConfig = {
    previousSection: previousSectionName,
    nextSection: nextSectionName,
    title: {
        fr: 'Questionnaire complété',
        en: 'Survey completed'
    },
    navMenu: {
        type: 'hidden',
        parentSection: parentSection
    },
    widgets: widgetsNames_1.widgetsNames,
    // Do some actions before the section is loaded
    preload: customPreload_1.customPreload,
    // Allow to click on the section menu
    enableConditional: function (interview) {
        return (0, navigationHelpers_1.isSectionCompleted)({ interview, sectionName: previousSectionName });
    },
    // Allow to click on the section menu
    completionConditional: function (interview) {
        return (0, navigationHelpers_1.isSectionCompleted)({ interview, sectionName: exports.currentSectionName });
    },
    onSectionEntry: function (interview) {
        const needUpdateHouseholdSize = (0, customHelpers_1.updateHouseholdSizeFromPersonCount)(interview);
        const isCompleted = (0, helpers_1.getResponse)(interview, '_isCompleted', false);
        if (!isCompleted) {
            // If the survey is not completed, we set the _interviewFinished response to true to tell the server to complete the survey
            // FIXME This is a temporary fix, to make sure the server completes the survey with server timestamp, until it is done automatically by evolution when https://github.com/chairemobilite/evolution/issues/1026 is fixed
            const updatedValues = { 'response._interviewFinished': true };
            return needUpdateHouseholdSize ? (0, merge_1.default)(updatedValues, needUpdateHouseholdSize) : updatedValues;
        }
        return needUpdateHouseholdSize;
    }
};
exports.default = exports.sectionConfig;
